import(/* webpackMode: "eager" */ "/vercel/path0/app/terminal/page.tsx");
